// billing strings (es).
// Machine-drafted — review with a native speaker before launch.
const billing = {
	billing: {
		// Billing overview
		billingTitle: 'Facturación',
		backToBilling: 'Volver a Facturación',
		backToBillingLower: 'volver a facturación',
		grabExclusiveDeals: 'Aprovecha nuestras ofertas exclusivas %{type}',
		lifetime: 'De por vida',
		monthly: 'Mensual',
		insteadOfRegular: 'En lugar de nuestro precio habitual',
		regularPriceStrike: '$9 por usuario/por mes',
		pricingSuffix: 'precio,',
		limitedTimeOffer: 'ofrecemos una oferta de por vida con un solo pago por tiempo limitado.',
		annual: 'Anual',
		twentyPercentOff: '20% de descuento',

		// Plan detail
		noPlanSelected: 'Ningún plan seleccionado',
		trialPeriod: 'Período de prueba',
		upcomingInvoice: 'Tu próxima factura. Se te cobrará después de %{days}',
		days14: '14 días.',
		days30: '30 días.',
		days365: '365 días.',
		notSubscribed: 'Estimado usuario, no estás suscrito a ningún plan. Por favor, actualiza tu plan.',
		planLineItem: '%{members} usuario x Plan %{plan} (a $%{price})',
		noWord: 'Ningún',
		total: 'Total',
		upgradePlan: 'Mejorar plan',
		managePayment: 'Gestionar pago',
		cancelSubscription: 'Cancelar suscripción',

		// Cancel subscription confirmation
		areYouSure: '¿Estás seguro?',
		cancelSubConfirm: '¿Quieres cancelar tu suscripción actual?',
		no: 'No',
		yes: 'Sí',

		// Plan limits
		limits: 'Límites',
		workspace: 'Espacio de trabajo',
		teamMembers: 'Miembros del equipo',
		uniqueRecipients: 'Destinatarios únicos',
		cards: 'Tarjetas',
		aiCredits: 'Créditos de IA',
		emailAccountsLabel: 'Cuentas de correo',
		of: 'de',
		used: 'usados',
		ofUnlimitedUsed: 'de ilimitados usados',
		willBeRefreshed: 'se renovará el %{date}',
		lifetimeSubscription: 'Tienes una suscripción de plan de por vida.',
		recipientsLimitTooltip: 'Límite de destinatarios %{expiry}',
		cardsLimitTooltip: 'Límite de tarjetas %{expiry}',
		aiCreditsLimitTooltip: 'Límite de créditos de IA %{expiry}',

		// Redeem codes
		cannotRedeemMore: 'No se pueden canjear más de 8 códigos',
		codeAlreadyAdded: 'El código ya fue agregado',
		enterAppsumoCodeTitle: 'Ingresa el código de AppSumo',
		hitPlusIcon: "Pulsa el ícono '+' o presiona enter después de escribir tu código",
		planUpdated: '¡Plan actualizado!',
		redeem: 'Canjear',
		cancel: 'Cancelar',

		// Common swal titles
		successTitle: 'Éxito',
		errorTitle: 'Error',
		oopsTitle: 'Ups',

		// Receipts / data table
		receipts: 'Recibos',
		paymentHistory: 'Tu historial de pagos de tu suscripción en CardClan',
		view: 'Ver',
		id: 'Id',
		plan: 'Plan',
		price: 'Precio',
		totalCards: 'Total de tarjetas',
		date: 'Fecha',

		// Change plan
		changePlan: 'Cambiar plan',

		// Email accounts list
		emailsTitle: 'Correos',
		connectEmailAccount: 'Conectar cuenta de correo',
		connectEmailAccountBtn: 'Conectar cuenta de correo',
		needHelpConnecting: '¿Necesitas ayuda para conectar la cuenta de correo?',
		successfullyDeleted: 'Eliminado correctamente',
		deleteAccountError: 'Ocurrió un error al eliminar tu cuenta. ¡Por favor, inténtalo de nuevo!',
		noEmailAccountLimit: 'Tu plan no permite crear cuentas de correo. Actualiza tu plan para agregar cuentas de correo.',
		noEmailAccounts: 'Aún no hay cuentas de correo conectadas.',
		getStartedConnecting: 'Comienza conectando una nueva cuenta de correo.',
		howToSetupSmtp: '¿Cómo configurar una cuenta de remitente SMTP?',

		// Email account modal
		editEmailAddress: 'Editar dirección de correo',
		addEmailAddress: 'Agregar dirección de correo',
		fromName: 'Nombre del remitente',
		userName: 'nombre de usuario',
		smtpHost: 'Host SMTP',
		differentReplyTo: 'Establecer una dirección de respuesta diferente',
		fromEmail: 'Correo del remitente',
		passwordLabel: 'contraseña',
		smtpPort: 'Puerto SMTP',
		ssl: 'SSL',
		tls: 'TLS',
		replyTo: 'Responder a',
		updateSettings: 'Actualizar configuración',
		saveSettings: 'Guardar configuración',
		accountUpdated: 'Tu cuenta de correo se ha actualizado correctamente',
		accountConnected: 'Tu cuenta de correo se ha conectado correctamente',
		minChars: 'debe tener al menos 2 caracteres ',
		maxChars: 'debe tener como máximo 25 caracteres ',
		invalidEmail: 'Formato de correo inválido',
		emailRequired: 'El correo es obligatorio',
		port25Blocked:
			'Las solicitudes de correo a través del puerto 25 están bloqueadas por los servidores del host. Se recomienda usar otro puerto para esta operación.',

		// Email account table
		name: 'Nombre',
		status: 'Estado',
		action: 'Acción',
		active: 'Activa',
		edit: 'Editar',
		deleteWord: 'Eliminar',

		// White label
		whiteLabel: 'Marca blanca',
		noCustomDomain: 'Aún no tienes configurado tu dominio personalizado.',
		brandPresets: 'Ajustes de marca',
		brandingDescription: 'Esta es tu marca que aparecerá en toda la plataforma',
		appTitle: 'Título de la app',
		appTitlePlaceholder: 'p. ej. mi-app',
		brandColorsTitle: 'Colores de marca',
		reset: 'Restablecer',
		save: 'Guardar',
		clickSaveToUpdate: 'Haz clic en el botón Guardar para actualizar tus cambios.',
		invalidFile: '¡Archivo inválido!',
		uploadLogo: 'Subir logo',
		uploadImage: 'Subir imagen',
		uploading: 'Subiendo...',

		// Logo / color labels
		darkLogo: 'Logo oscuro',
		lightLogo: 'Logo claro',
		favicon: 'Favicon',
		accentColor: 'Color de acento',
		backgroundColor: 'Color de fondo',
		sidebarColor: 'Color de barra lateral',

		// Workspace domain
		workspaceDomain: 'Dominio del espacio de trabajo',
		loading: 'Cargando...',
		domainsUsed: '%{used} de %{limit} dominios de espacio de trabajo usados',
		customDomainFor: 'Dominio personalizado para "%{name}"',
		currentWorkspaceFallback: 'Espacio de trabajo actual',
		assignDomainDesc: 'Asigna un dominio personalizado a este espacio de trabajo para enlaces de tarjetas con tu marca',
		domainName: 'Nombre de dominio',
		saveDomain: 'Guardar dominio',
		checkDns: 'Verificar DNS',
		cnameInstructions:
			'Agrega el siguiente registro CNAME en la configuración de tu DNS. Tu webmaster o administrador del servidor puede ayudarte a configurarlo.',
		typeCol: 'Tipo',
		keyCol: 'Clave',
		valueCol: 'Valor',
		copy: 'copiar',
		invalidDomain: 'Dominio inválido. No incluyas el protocolo (http/https)',
		domainRequired: 'El dominio es obligatorio',
		domainCreated: 'Dominio del espacio de trabajo creado. Configura tu DNS y verifica.',
		failedCreateDomain: 'No se pudo crear el dominio',
		domainVerified: '¡Dominio verificado correctamente! Ahora está activo.',
		verificationFailed: 'Verificación fallida',
		dnsVerificationFailed: 'La verificación de DNS falló. Asegúrate de que el CNAME apunte a ssl.cardclan.me',
		deletedTitle: 'Eliminado',
		domainRemoved: 'El dominio del espacio de trabajo ha sido eliminado.',
		failedDeleteDomain: 'No se pudo eliminar el dominio',

		// Workspace domain add-on
		addonTitle: 'Complemento de dominios personalizados para espacios de trabajo',
		addonDesc:
			'Asigna dominios personalizados únicos a espacios de trabajo individuales. Cada espacio de trabajo puede tener su propio dominio con marca para enlaces de tarjetas.',
		addonHeading: 'Dominios personalizados para espacios de trabajo',
		addonSubDesc: 'Cada unidad te da 3 dominios personalizados de espacio de trabajo. Ajusta la cantidad para obtener más.',
		perMonth: '/mes',
		workspaceDomainsCount: '%{count} dominios de espacio de trabajo',
		featureDomainsPerUnit: '3 dominios personalizados de espacio de trabajo por unidad',
		featureDnsVerification: 'Verificación de DNS con CNAME',
		featureAdjustableQty: 'Cantidad ajustable al finalizar la compra',
		purchaseAddon: 'Comprar complemento',

		// Video card settings
		videoCardSettingsPageTitle: 'Configuración de tarjetas de video | CardClan',
		videoCards: 'Tarjetas de video',
		videoCardsDesc: 'Controla si las tarjetas de video están disponibles para los miembros de este espacio de trabajo.',
		enableVideoCards: 'Habilitar tarjetas de video',
		enableVideoCardsDesc:
			'Cuando está deshabilitado, los miembros del espacio de trabajo no pueden crear tarjetas de video ni acceder a la sección de tarjetas de video.',
		saved: '¡Guardado!',
		failedSave: 'No se pudo guardar',
		enabled: 'Habilitado',
		disabled: 'Deshabilitado',

		// Integration key
		generateIntegrationKey: 'Generar clave de integración',
		integrationKeyDesc: 'Usa esta clave para conectar con plataformas de automatización externas como Pabbly Connect',
		integrationKeyCreated: 'La clave de integración se ha creado correctamente.',
		usageInstructions: 'Instrucciones de uso:',
		usageStep1: 'Copia esta clave en tu portapapeles',
		usageStep2: 'En Pabbly Connect, crea una nueva conexión',
		usageStep3: 'Pega esta clave como el token Bearer o la clave API',
		integrationKeyExists: 'La clave de integración ya existe',
		integrationKeyExistsDesc:
			'Ya tienes una clave de integración para una plataforma diferente. Solo puedes tener una clave de integración por cuenta.',
		integrationKeyGenerated: '¡Clave de integración generada correctamente!',
		failedGenerateIntegrationKey: 'No se pudo generar la clave de integración',
		integrationKeyCopied: 'Clave de integración copiada correctamente',

		// Zapier key
		generateZapierKey: 'Generar clave de Zapier',
		generateZapierKeyBtn: 'Generar clave de Zapier',
		zapierKeyDesc: 'Usa esta clave en tu app de Zapier para la autenticación',
		zapierKeyCreated: 'La clave de Zapier se ha creado correctamente.',
		keyCopied: 'Clave de %{title} copiada correctamente',

		// Preview card
		previewCard: 'Vista previa de la tarjeta',
		previewCardDesc: 'Personaliza cómo se ve tu tarjeta en un correo y cuando alguien la abre.',
		chooseCardBackground: 'Elegir fondo de la tarjeta',
		background: 'Fondo',
		toggleConfetti: 'Alternar confeti',
		addCompanyLogo: 'Agregar logo de la empresa',
		logoDimensionNote: '* para una vista óptima, el logo de la empresa debe tener dimensiones de 400 x 100',
		viewCardButtonDesign: 'Diseño del botón “Ver tarjeta” del correo',
		preview: 'Vista previa',
		buttonText: 'Texto del botón',
		buttonRounded: 'Botón redondeado',
		buttonColor: 'Color del botón',
		saveChanges: 'Guardar cambios',
		viewChanges: 'Ver cambios',
		changesSaved: 'Cambios guardados correctamente.',
		previewGreeting: 'Hola nombre, %{name} creó una tarjeta digital',
		previewFooter: 'Tu bandeja de entrada acaba de recibir una entrega especial. Ve tu tarjeta en línea.',

		// Settings navigation
		navYourProfile: 'Tu perfil',
		navBilling: 'Facturación',
		navManageWorkspaces: 'Gestionar espacios de trabajo',
		navBasicSettings: 'Configuración básica',
		navTeamMembers: 'Miembros del equipo',
		navEmailAccounts: 'Cuentas de correo',
		navCustomDomainSettings: 'Configuración de dominio personalizado',
		navDashboard: 'Panel',
		navMyCards: 'Mis tarjetas',
		navSettings: 'Configuración',
		accountSettings: 'Configuración de la cuenta',
		whiteLabelSettingsSection: 'Configuración de marca blanca',
	},
};
export default billing;
